/* Hero loop playback.
 *
 * The markup already carries autoplay/muted/loop/playsinline, which is enough
 * for Chrome and for Safari under normal conditions. It is not enough in three
 * real cases, and in all three Safari falls back to its own player chrome: a
 * grey scrim with a play button over the middle of the page, which looks far
 * worse than no video at all.
 *
 *   1. macOS Low Power Mode. Safari suspends all video autoplay, full stop.
 *      Nothing a page can do changes this.
 *   2. Safari's per-site Auto-Play setting left on "Never Auto-Play".
 *   3. The tab was opened in the background, so the first play() is refused.
 *
 * So: ask for playback explicitly, retry when the tab becomes visible or on the
 * first interaction, and if it is still refused, swap to a clean still frame.
 * The still is the same frame the loop starts on, all five labels to camera, so
 * a reader who never gets the animation still gets a correct product shot
 * rather than a broken-looking player.
 */
(function () {
  'use strict';

  /* Two kinds of container now use this. .hero-film is the full-screen loop,
     which swaps to a still frame if playback is refused. .autoplay-film is a
     framed film in the flow: it carries its own controls, so a refusal already
     shows the browser's poster and play button and there is nothing to swap to.
     The retry logic is identical for both, which is the whole reason this is a
     loop rather than two copies of the same file. */
  var films = document.querySelectorAll('.hero-film, .autoplay-film');
  if (!films.length) return;
  Array.prototype.forEach.call(films, function (film) {
    var v = film.querySelector('video');
    if (!v) return;
    setup(film, v);
  });

  function setup(film, v) {
  var swapsToStill = film.classList.contains('hero-film');

  // Set these as properties too, not only as attributes. Safari consults the
  // property when it decides whether a play() call counts as muted autoplay.
  v.muted = true;
  v.playsInline = true;

  /* Guard on the element's own state rather than a "have we settled" flag. A
     flag looks equivalent and is not: Safari suspends playback again when the
     machine drops into Low Power Mode mid-visit, and a latched flag would stop
     every retry from that point on. Asking v.paused always tells the truth. */
  function attempt() {
    if (!v.paused) return;
    /* 9 Sep 2026, mobile: once tilt.js has put its canvas up, the film under it
       is hidden and tilt.js pauses it. Retrying play() here would restart a
       video nobody can see, which on a phone is decode work and battery for
       nothing. The stage carries .is-live from that moment; leave it alone. */
    if (film.classList.contains('is-live')) return;
    var p = v.play();
    if (!p || !p.then) return;                  // older browsers return nothing
    p.then(function () {
      if (swapsToStill) film.classList.remove('is-still');
    }).catch(function () { /* keep waiting for a retry hook */ });
  }

  attempt();

  // Retry hooks. Each is a moment a browser may newly permit playback.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) attempt();
  });
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (e) {
    document.addEventListener(e, attempt, { once: true, passive: true });
  });

  /* Keep the still in sync with reality, and keep trying for a while.
     A single check at first paint is not enough on two counts: the refusal can
     arrive after first paint, and it can lift again, for instance when the
     machine comes off Low Power Mode. So this both re-asks for playback and
     re-labels, and it gives up asking after a dozen rounds so a genuinely
     blocked page is not calling play() forever. The label keeps tracking after
     that, since the retry hooks above can still start it. */
  var tries = 0;
  setInterval(function () {
    /* Once the tilt canvas owns the stage the film is paused on purpose. Do not
       relabel it as a still either: .is-still hides the video, and on a phone
       the video's aspect is what gives the stage its height. */
    if (film.classList.contains('is-live')) return;
    if (v.paused && tries++ < 12) attempt();
    if (swapsToStill) film.classList.toggle('is-still', v.paused);
  }, 1200);
  }
})();
